import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    tokens: {
        // Brutalist avoids blur everywhere else (SectionContainer/WebButton/Card
        // are all hard-edged) — keep the lightbox backdrop consistent.
        "--theme-modal-blur": "none",
    },
};
